export default __webpack_public_path__ + "b418d9052a81240c6acb7fc251fbb4b3.svg";